import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  postStatementRequestNum,
  getStatementHeader,
  exportStatementPdf,
} from "../../../actions/statementAction";
import "../Dashboard.css";

const PAGE_SIZE = 10;

export default function StatementTab(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [response, setResponse] = useState(null);

  const [requestLoading, setRequestLoading] = useState(false);
  const [requestStatAlert, setRequestStatAlert] = useState(false);

  // Call statement data from API
  const statementInfo = useSelector((state) => state.getStatementHeader);
  const { statementHeader, loading, error } = useSelector(
    (state) => state.getStatementHeader
  );

  // Pagination -------------------------------------
  const [page, setPage] = useState(1);
  const totalItems = statementHeader?.length ?? 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const pageStart = (safePage - 1) * PAGE_SIZE;

  const startIndex = totalItems === 0 ? 0 : pageStart + 1;
  const endIndex = Math.min(safePage * PAGE_SIZE, totalItems);
  //const showingCount = totalItems === 0 ? 0 : endIndex - startIndex + 1;
  const pagedData =
    statementHeader?.slice(pageStart, safePage * PAGE_SIZE) ?? [];
  const showingCount = pagedData.length;

  // page move button
  const goToPage = (n) => setPage(Math.min(Math.max(1, n), totalPages));
  const prev = () => goToPage(safePage - 1);
  const next = () => goToPage(safePage + 1);

  // keep 5 buttons window
  const getWindowPages = (current, total, size = 5) => {
    if (total <= size) return Array.from({ length: total }, (_, i) => i + 1);
    const half = Math.floor(size / 2); // 2
    let start = current - half;
    let end = current + half;
    if (start < 1) {
      start = 1;
      end = size;
    }
    if (end > total) {
      end = total;
      start = total - size + 1;
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  //-------------------------------------------------

  useEffect(() => {
    dispatch(getStatementHeader());
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const handleRequestStatementClick = async () => {
    try {
      // Start loading
      // setRequestLoading(true);

      // Call API
      const res = await dispatch(postStatementRequestNum());
      setResponse(res);

      if (
        res.data.result.id ||
        res?.data?.statusCode === 200 ||
        res?.data?.isSuccess
      ) {
        setRequestStatAlert(true); //  only after both payment + email succeed

        // alert(
        //   `Your statement (Request No. ${response.data.result.id}) has been successfully retrieved.\nPlease check the requested statement after one minute.`
        // );

        // After adding new statement data, reload the statementHeader data
        dispatch(getStatementHeader());
      } else {
        alert(
          "Something happens. Please contact to Maevn customer service team to request your latest statement."
        );
      }
    } catch (error) {
      console.error(error);
      alert(
        "Something happens. Please contact to Maevn customer service team to request your latest statement."
      );
    } finally {
      // End loading
      // setRequestLoading(false);
    }
  };

  // Date format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // view a statement
  const viewStatement = (statementId) => {
    console.log("Viewing invoice with statementId:", statementId);

    // for moving dashboard tab (update parent component's state)
    props.setSelectedStatementId(statementId);
  };

  // Download a statement
  const handleClickDownloadStatement = (statementid) => {
    dispatch(exportStatementPdf(statementid));
  };

  return (
    <>
      <div
        className="w-full bg-[#F8F9FA] mb-10px"
        style={{
          borderTop: "1px solid var(--Main-Stroke, #C3C3C3)",
        }}
      >
        {/* Statement Title */}
        <div className="invoice-title">Statements</div>

        {/* Statement Table Wrapper */}
        <div className="statement-table-wrapper">
          <div className="statement-table-header">
            {/* Request Button */}
            <button
              className="pay-invoice-button"
              style={{
                width: "215px",
                height: "40px",
              }}
              onClick={handleRequestStatementClick}
            >
              Request New Statement
            </button>

            {/* Payment approval alert */}
            {requestStatAlert && (
              <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                <div className="bg-white p-8 rounded-lg shadow-lg w-[580px]">
                  <h3
                    className="font-semibold text-xl mb-2"
                    style={{ color: "#04ADD1" }}
                  >
                    Your statement request has been received.
                  </h3>
                  <p className="text-gray-700 text-base">
                    A summary record has been created.
                  </p>
                  <p className="text-gray-700 text-base">
                    The detailed statement data is being prepared and will be
                    available within <strong>1–2 minutes</strong>.
                  </p>
                  <p className="text-gray-700 text-base mb-4">
                    Please check your requested statement again shortly.
                  </p>

                  <p className="text-gray-800 text-base mb-2">
                    <strong>Request No.:</strong>{" "}
                    <span className="text-[#04ADD1] font-semibold">
                      {response?.data?.result?.id}
                    </span>
                  </p>

                  <div className="text-center mt-6">
                    <button
                      className="bg-[#04ADD1] hover:bg-[#0399B8] text-white px-10 py-2.5 rounded-md text-base font-medium shadow-sm"
                      onClick={() => setRequestStatAlert(false)}
                    >
                      OK
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/*
            {requestLoading ? (
              <button className="pay-invoice-button loading" disabled>
                Your statement is loading... Please wait.
              </button>
            ) : (
              <button
                className="pay-invoice-button"
                style={{
                  width: "215px",
                  height: "40px",
                }}
                onClick={handleRequestStatementClick}
              >
                Request New Statement
              </button>
            )} 
            */}
          </div>
          {/* Statement Table */}
          <table className="statement-table">
            <thead>
              <tr className="statement-header-row">
                <th>
                  <div className="statement-header-row-cell">
                    Request Number
                  </div>
                </th>
                <th>
                  <div className="statement-header-row-cell">
                    Statement Date
                  </div>
                </th>
                <th>
                  <div className="statement-header-row-cell">Status</div>
                </th>
                <th>
                  <div className="statement-header-row-cell">View/ Save</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {statementHeader
                ?.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE)
                .map((statement) => (
                  <tr
                    className="statement-body-row"
                    key={statement.requestedNo}
                  >
                    <td>
                      <div className="statement-row-cell">
                        {statement.requestedNo}
                      </div>
                    </td>
                    <td>
                      <div className="statement-row-cell">
                        {formatDate(statement.statementDate)}
                      </div>
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <div className="status-badge current">
                        {statement.status}
                      </div>
                    </td>
                    <td>
                      {statement.status === "Processed" ? (
                        <div className="statement-row-cell-view-save">
                          <Link
                            type="button"
                            onClick={() => viewStatement(statement.requestedNo)}
                            to="/myaccount#viewStatement"
                            style={{
                              width: "20px",
                              height: "15px",
                              flexShrink: 0,
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="15"
                              viewBox="0 0 20 15"
                              fill="none"
                            >
                              <path
                                d="M0.716757 8.21957C0.594405 8.21957 0.46924 8.1885 0.356733 8.12071C0.0149911 7.92016 -0.100329 7.47952 0.0979654 7.13634C0.7041 6.09265 2.00919 4.0999 3.94854 2.46869C5.89351 0.83043 7.9299 0 9.99863 0C10.3952 0 10.7159 0.322004 10.7159 0.720271C10.7159 1.11854 10.3952 1.44054 9.99863 1.44054C6.36183 1.44054 3.13989 4.75803 1.33696 7.86226C1.20335 8.09105 0.962868 8.21957 0.716757 8.21957Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99859 14.9987C7.92986 14.9987 5.89347 14.1683 3.94709 12.53C2.00915 10.8988 0.702653 8.90465 0.0979243 7.86237C-0.101777 7.51918 0.0135436 7.07714 0.356692 6.878C0.698434 6.67746 1.13721 6.79326 1.33691 7.13786C3.13985 10.2421 6.36319 13.5596 9.99859 13.5596C10.3952 13.5596 10.7158 13.8816 10.7158 14.2799C10.7158 14.6781 10.3952 15.0001 9.99859 15.0001V14.9987Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99849 14.9987C9.6019 14.9987 9.28125 14.6767 9.28125 14.2784C9.28125 13.8802 9.6019 13.5582 9.99849 13.5582C13.6353 13.5582 16.8572 10.2407 18.6602 7.13645C18.8599 6.79327 19.2986 6.67605 19.6404 6.87659C19.9821 7.07714 20.0974 7.51777 19.8992 7.86096C19.293 8.90465 17.9879 10.8974 16.0486 12.5286C14.1022 14.1669 12.0672 14.9973 9.99708 14.9973L9.99849 14.9987Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M19.2823 8.21957C19.0362 8.21957 18.7957 8.09105 18.6621 7.86226C16.8592 4.75803 13.6358 1.44054 10.0004 1.44054C9.60385 1.44054 9.2832 1.11854 9.2832 0.720271C9.2832 0.322004 9.60385 0 10.0004 0C12.0692 0 14.1056 0.83043 16.0519 2.46869C17.9913 4.0999 19.2964 6.09406 19.9025 7.13634C20.1022 7.47952 19.9869 7.92157 19.6437 8.12071C19.5298 8.18709 19.4061 8.21957 19.2837 8.21957H19.2823Z"
                                fill="#A6A5A3"
                              />
                              <path
                                d="M9.99874 12.0329C7.50951 12.0329 5.48438 9.99918 5.48438 7.49942C5.48438 4.99965 7.50951 2.96594 9.99874 2.96594C12.488 2.96594 14.5131 4.99965 14.5131 7.49942C14.5131 9.99918 12.488 12.0329 9.99874 12.0329ZM9.99874 4.40649C8.29988 4.40649 6.91885 5.79336 6.91885 7.49942C6.91885 9.20547 8.29988 10.5923 9.99874 10.5923C11.6976 10.5923 13.0786 9.20547 13.0786 7.49942C13.0786 5.79336 11.6976 4.40649 9.99874 4.40649Z"
                                fill="#A6A5A3"
                              />
                            </svg>
                          </Link>
                          <div
                            onClick={() =>
                              handleClickDownloadStatement(statement.id)
                            }
                            className="text-center"
                            style={{
                              width: "18px",
                              height: "18px",
                              flexShrink: 0,
                              cursor: "pointer",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                            >
                              <path
                                d="M16 9V16H2V9H0V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V9H16ZM10 9.67L12.59 7.09L14 8.5L9 13.5L4 8.5L5.41 7.09L8 9.67V0H10V9.67Z"
                                fill="#A6A5A3"
                              />
                            </svg>
                          </div>
                        </div>
                      ) : (
                        // Empty space or alternative content for non-Processed status
                        <div className="statement-row-cell"></div>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {/* Pagination footer */}
          <div className="pager">
            <div className="pager__message">
              {`Page ${safePage} - Showing  ${showingCount} item${
                showingCount === 1 ? "" : "s"
              }`}
            </div>
          </div>

          {/* Pagination buttons container */}
          <div className="pager__wrap" aria-label="Pagination">
            {/* prev */}
            <button
              type="button"
              onClick={prev}
              disabled={safePage === 1}
              className={`pager__arrow ${safePage === 1 ? "is-edge" : ""}`}
              aria-label="Previous page"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M5.04384 7.16063L10.2685 2.1825C10.3557 2.0994 10.4715 2.05304 10.592 2.05304C10.7124 2.05304 10.8282 2.0994 10.9154 2.1825L10.921 2.18813C10.9634 2.22842 10.9972 2.27691 11.0203 2.33066C11.0434 2.38441 11.0553 2.44229 11.0553 2.50078C11.0553 2.55928 11.0434 2.61716 11.0203 2.67091C10.9972 2.72466 10.9634 2.77315 10.921 2.81344L6.00103 7.50094L10.921 12.1866C10.9634 12.2269 10.9972 12.2753 11.0203 12.3291C11.0434 12.3828 11.0553 12.4407 11.0553 12.4992C11.0553 12.5577 11.0434 12.6156 11.0203 12.6693C10.9972 12.7231 10.9634 12.7716 10.921 12.8119L10.9154 12.8175C10.8282 12.9006 10.7124 12.947 10.592 12.947C10.4715 12.947 10.3557 12.9006 10.2685 12.8175L5.04384 7.83938C4.9979 7.7956 4.96131 7.74295 4.93632 7.68461C4.91133 7.62627 4.89844 7.56347 4.89844 7.5C4.89844 7.43654 4.91133 7.37373 4.93632 7.3154C4.96131 7.25706 4.9979 7.20441 5.04384 7.16063Z"
                  fill="#0B0B0B"
                />
              </svg>
            </button>

            {/* 5 buttons */}
            {getWindowPages(safePage, totalPages, 5).map((p) => (
              <button
                key={p}
                type="button"
                onClick={() => goToPage(p)}
                className={
                  p === safePage ? "pager__btn--selected" : "pager__btn"
                }
                aria-current={p === safePage ? "page" : undefined}
              >
                {p}
              </button>
            ))}

            {/* next */}
            <button
              type="button"
              onClick={next}
              disabled={safePage === totalPages}
              className={`pager__arrow ${
                safePage === totalPages ? "is-edge" : ""
              }`}
              aria-label="Next page"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
              >
                <path
                  d="M9.95616 7.16063L4.73147 2.1825C4.64429 2.0994 4.52847 2.05304 4.40803 2.05304C4.28759 2.05304 4.17177 2.0994 4.08459 2.1825L4.07897 2.18813C4.03656 2.22842 4.00279 2.27691 3.97972 2.33066C3.95664 2.38441 3.94474 2.44229 3.94474 2.50078C3.94474 2.55928 3.95664 2.61716 3.97972 2.67091C4.00279 2.72466 4.03656 2.77315 4.07897 2.81344L8.99897 7.50094L4.07897 12.1866C4.03656 12.2269 4.00279 12.2753 3.97972 12.3291C3.95664 12.3828 3.94474 12.4407 3.94474 12.4992C3.94474 12.5577 3.95664 12.6156 3.97972 12.6693C4.00279 12.7231 4.03656 12.7716 4.07897 12.8119L4.08459 12.8175C4.17177 12.9006 4.28759 12.947 4.40803 12.947C4.52847 12.947 4.64429 12.9006 4.73147 12.8175L9.95616 7.83938C10.0021 7.7956 10.0387 7.74295 10.0637 7.68461C10.0887 7.62627 10.1016 7.56347 10.1016 7.5C10.1016 7.43654 10.0887 7.37373 10.0637 7.3154C10.0387 7.25706 10.0021 7.20441 9.95616 7.16063Z"
                  fill="#0B0B0B"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
